<section>
    <div class="fakeLoader"></div>
    <div id="page-wrapper">
      <div class="row page-titles">
        <div class="col-md-12">
          <h3 class="text-themecolor">{{formTitle}}</h3>
        </div>
      </div>
      <div class="loader-overlay" *ngIf="isLoading">
        <div class="loader"></div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div *ngIf="!isLoading && formStructure.length > 0">
              <form [formGroup]="previewForm" (ngSubmit)="onSubmit()">
                <div class="card">
                  <div class="card-header">
                    <h4>Application</h4>
                  </div>
                  <div class="card-body">
                    <p class="required-note">* Denotes Required Field.</p>
                    <div class="row">
                      <!-- Loop through formStructure and apply isFieldVisible condition -->
                      <ng-container *ngFor="let field of formStructure">
                        <div *ngIf="isFieldVisible(field)" [ngClass]="getGridClass(field)">
                          <ng-container [ngSwitch]="field.field_type_name.toLowerCase()">

                            <!-- Display-only fields -->
                            <div *ngSwitchCase="'heading'" [innerHTML]="field.safeContent" class="col-sm-12 mrg-bot-15">
                            </div>
                            <div *ngSwitchCase="'release'" [innerHTML]="field.safeContent" class="col-sm-12 mrg-bot-15">
                            </div>
                            <div *ngSwitchCase="'paragraph'" [innerHTML]="field.safeContent"
                              class="col-sm-12 mrg-bot-15"></div>

                            <!-- Interactive Fields -->
                            <ng-container *ngSwitchDefault>
                              <div class="form-group">
                                <!-- Generic Label (skip for declaration, checkbox, radio) -->
                                <label
                                  *ngIf="!['declaration','checkbox','radio', 'table'].includes(field.field_type_name.toLowerCase())"
                                  [for]="field.field_id">
                                  {{ field.field_name }}
                                  <span *ngIf="field.mandatory === 1" class="text-danger">*</span>
                                </label>

                                <!-- RADIO -->
                              <div *ngIf="field.field_type_name.toLowerCase() === 'radio'" class="choice-group-wrapper">
                                  <!-- ADD THIS LABEL FOR THE ENTIRE RADIO GROUP -->
                                  <label [for]="field.field_id">
                                    {{ field.field_name }}
                                    <span *ngIf="field.mandatory === 1" class="text-danger">*</span>
                                  </label>
                                  <div class="choice-group" [ngClass]="{'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                      previewForm.get(field.field_id + '')?.touched}">
                                    <div class="choice" *ngFor="let opt of field.options; let j = index">
                                      <input type="radio" [value]="opt" [formControlName]="field.field_id + ''"
                                        [name]="field.field_id + ''" [id]="'radio_' + field.field_id + '_' + j"
                                        (click)="toggleRadioSelection(field.field_id, opt)" />
                                      <label [for]="'radio_' + field.field_id + '_' + j">{{ opt }}</label>
                                    </div>
                                  </div>
                                </div>

                                <!-- CHECKBOX -->
                                <div *ngIf="field.field_type_name.toLowerCase() === 'checkbox'"
                                  class="choice-group-wrapper">
                                  <!-- ADD THIS LABEL FOR THE ENTIRE CHECKBOX GROUP -->
                                  <label [for]="field.field_id">
                                    {{ field.field_name }}
                                    <span *ngIf="field.mandatory === 1" class="text-danger">*</span>
                                  </label>
                                  <div class="choice-group" [ngClass]="{'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                      previewForm.get(field.field_id + '')?.touched}">
                                    <div class="choice" *ngFor="let opt of field.options; let j = index">
                                      <input type="checkbox" [id]="'chk_' + field.field_id + '_' + j"
                                        (change)="onCheckboxToggle(field.field_id, opt, $event.target?.checked)"
                                        [checked]="previewForm.get(field.field_id + '')?.value?.includes(opt)" />
                                      <label [for]="'chk_' + field.field_id + '_' + j">{{ opt }}</label>
                                    </div>
                                  </div>
                                </div>

                                  <!-- Table Field -->
                              <div *ngIf="field.field_type_name.toLowerCase() === 'table'" class="table-responsive">
                                <label>{{ field.field_name }} <span *ngIf="field.mandatory === 1"
                                    class="text-danger">*</span></label>
                                <table class="table table-bordered table-hover">
                                  <thead class="thead-light">
                                    <!-- Header Row 1 -->
                                    <tr>
                                      <ng-container *ngFor="let col of field.tableColumns">
                                        <th [attr.rowspan]="col.subColumns?.length ? 1 : 2"
                                          [attr.colspan]="col.subColumns?.length || 1" class="text-center align-middle">
                                          {{ col.header }}
                                        </th>
                                      </ng-container>
                                      <th rowspan="2" style="width: 50px;" class="text-center align-middle">Action</th>
                                    </tr>
                                    <!-- Header Row 2 (Sub-columns) -->
                                    <tr>
                                      <ng-container *ngFor="let col of field.tableColumns">
                                        <ng-container *ngIf="col.subColumns?.length">
                                          <th *ngFor="let subCol of col.subColumns" class="text-center">
                                            {{ subCol.header }}
                                          </th>
                                        </ng-container>
                                      </ng-container>
                                    </tr>
                                  </thead>
                                  <tbody [formArrayName]="field.field_id + ''">
                                    <tr *ngFor="let row of getTableRowControls(field.field_id); let i = index"
                                      [formGroupName]="i">

                                      <!-- Iterate over LEAF columns only -->
                                       <ng-container *ngFor="let col of field.precalculatedLeafColumns">
                                        <td>
                                          <!-- TEXT TYPE -->
                                          <input *ngIf="col.type === 'text' || !col.type" type="text"
                                            class="form-control" [formControlName]="col.header"
                                            [placeholder]="col.header">

                                          <!-- DROPDOWN TYPE -->
                                          <select *ngIf="col.type === 'dropdown'" class="form-control"
                                            [formControlName]="col.header">
                                            <option value="" disabled selected>Select</option>
                                            <option *ngFor="let opt of col.options" [value]="opt">{{ opt }}</option>
                                          </select>

                                            <!-- DATE TYPE -->
                                            <input *ngIf="col.type === 'date'" type="text"
                                              class="form-control custom-datepicker" [formControlName]="col.header"
                                              placeholder="DD/MM/YYYY" autocomplete="off">

                                          <!-- RADIO TYPE -->
                                          <div *ngIf="col.type === 'radio'" class="d-flex flex-wrap gap-2">
                                            <div *ngFor="let opt of col.options" class="form-check me-2">
                                              <input class="form-check-input" type="radio" [value]="opt"
                                                [formControlName]="col.header" [id]="col.header + '_' + i + '_' + opt">
                                              <label class="form-check-label" [for]="col.header + '_' + i + '_' + opt">
                                                {{ opt }}
                                              </label>
                                            </div>
                                          </div>

                                          <!-- CHECKBOX TYPE -->
                                          <div *ngIf="col.type === 'checkbox'" class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                              [formControlName]="col.header" [id]="col.header + '_' + i">
                                          </div>

                                          <!-- LABEL TYPE -->
                                          <span *ngIf="col.type === 'label'">{{col.header}}</span>

                                        </td>
                                      </ng-container>

                                      <td class="text-center align-middle">
                                        <button type="button" class="btn btn-outline-danger btn-sm"
                                          (click)="removeTableRow(field.field_id, i)" title="Remove Row">
                                          <i class="bi bi-trash"></i> ✕
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="addTableRow(field.field_id, field.precalculatedLeafColumns)">
                                </button>
                              </div>

                                <!-- Text / Input / Number / Email / Tel -->
                                <input
                                  *ngIf="['text','integer','mail to','phone number','age','full name','alphabet'].includes(field.field_type_name.toLowerCase())"
                                  class="form-control" [type]="
                                    field.field_type_name.toLowerCase() === 'mail to' ? 'email' :
                                    field.field_type_name.toLowerCase() === 'phone number' ? 'tel' :
                                    (field.field_type_name.toLowerCase() === 'integer' && field.input_type == 1) || field.field_type_name.toLowerCase() === 'age'
                                      ? 'number'
                                      : 'text'
                                   " [id]="field.field_id" [formControlName]="field.field_id + ''"
                                [placeholder]="field.field_attribute || ''" />

                                <div
                                  *ngIf="previewForm.get(field.field_id.toString())?.hasError('invalidPhoneNumber') && previewForm.get(field.field_id.toString())?.touched"
                                  class="text-danger">
                                  Phone number must be 10 digits and start with 9, 8, 7, or 6.
                                </div>


                                <!-- Time Input -->
                                <input *ngIf="field.field_type_name.toLowerCase() === 'time'" class="form-control"
                                  type="time" [id]="field.field_id" [formControlName]="field.field_id + ''" [ngClass]="{
        'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                      previewForm.get(field.field_id + '')?.touched
      }" />


                                <!-- Date -->
                                <input
                                  *ngIf="['date', 'dob', 'future date'].includes(field.field_type_name.toLowerCase())"
                                  type="text" class="form-control custom-datepicker" [id]="field.field_id"
                                  [formControlName]="field.field_id + ''" placeholder="DD/MM/YYYY" autocomplete="off"
                                  [ngClass]="{
                                    'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                                  previewForm.get(field.field_id + '')?.touched
                                  }" />


                                <!-- File -->
                                <input *ngIf="['image file', 'pdf file'].includes(field.field_type_name.toLowerCase())"
                                  class="form-control" type="file" [id]="field.field_id"
                                  (change)="onFileChange($event, field.field_id)"
                                  [accept]="field.field_type_name.toLowerCase() === 'image file' ? 'image/*' : 'application/pdf'"
                                  [ngClass]="{'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                    previewForm.get(field.field_id + '')?.touched}">

                                <!-- Long Text -->
                                  <textarea *ngIf="field.field_type_name.toLowerCase() === 'long text'" class="form-control"
                                rows="4" [id]="field.field_id" [formControlName]="field.field_id + ''"
                                [placeholder]="field.field_attribute || ''" [ngClass]="{'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                    previewForm.get(field.field_id + '')?.touched}">
      </textarea>

                                <!-- SELECT -->
                                <select
                                  *ngIf="['list', 'gender', 'country', 'market'].includes(field.field_type_name.toLowerCase())"
                                  class="form-control" [id]="field.field_id" [formControlName]="field.field_id + ''"
                                  [ngClass]="{'is-invalid': previewForm.get(field.field_id + '')?.invalid &&
                                    previewForm.get(field.field_id + '')?.touched}">
                                  <option value="" disabled selected>-- Select --</option>
                                  <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
                                </select>

                                <!-- Declaration -->
                                <div *ngIf="field.field_type_name.toLowerCase() === 'declaration'"
                                  class="form-check my-2 declaration-box">
                                  <input type="checkbox" class="form-check-input" [id]="field.field_id"
                                    [formControlName]="field.field_id + ''">
                                  <label class="form-check-label" [for]="field.field_id"
                                    [innerHTML]="field.safeContent"></label>
                                  <span *ngIf="field.mandatory === 1" class="text-danger">*</span>
                                </div>

                                <!-- 🔹 Validation Messages -->
                                <div
                                  *ngIf="previewForm.get(field.field_id + '')?.invalid && previewForm.get(field.field_id + '')?.touched"
                                  class="text-danger mt-1">
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['required']">
                                    {{field.field_name}} is required.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['minlength']">
                                    {{field.field_name}} must be at least {{field.min_length}} characters.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['maxlength']">
                                    {{field.field_name}} cannot exceed {{field.max_length}} characters.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['email']">
                                    {{field.field_name}} must be a valid email.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['pattern']">
                                    {{field.field_name}} has an invalid format.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['dobInvalid']">
                                    Date of Birth must be in the past.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['futureDate']">
                                    Date must be in the future.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['invalidDate']">
                                    Invalid date format. Please use DD/MM/YYYY.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['timeInvalid']">
                                    Invalid time format. Please use HH:MM.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['minTimeInvalid']">
                                    Time cannot be earlier than {{ field.field_attribute ?
                                    (parseFieldAttribute(field.field_attribute)?.timeValidation?.minTime || 'N/A') :
                                    'N/A' }}.
                                  </div>
                                  <div *ngIf="previewForm.get(field.field_id + '')?.errors?.['maxTimeInvalid']">
                                    Time cannot be later than {{ field.field_attribute ?
                                    (parseFieldAttribute(field.field_attribute)?.timeValidation?.maxTime || 'N/A') :
                                    'N/A' }}.
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                      <!-- Submit -->
                      <div class="row">
                        <div class="col-md-12 col-12 padd-top-15 text-center">
                          <button type="submit" class="btn btn-primary">SUBMIT</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div *ngIf="!isLoading && formStructure.length === 0" class="card">
              <div class="card-body">
                <p>This form has no fields to display</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>
<app-footer></app-footer>